import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pb-link-arrow-left',
  templateUrl: './pb-link-arrow-left.component.html',
  styleUrls: ['./pb-link-arrow-left.component.scss']
})
export class PbLinkArrowLeftComponent implements OnInit {

    @Input() content: any = {};
    @Input() module: any = {};
    padding_top: any = '';
    padding_bottom: any = '';
    item: any = {};

    constructor() { }

    ngOnInit(): void {

        this.content.forEach(element => {
            let data = element.data;

            try {
                data = JSON.parse(data);
            } catch (err) {
                data = {
                    text: '',
                    link: ''
                };
            }

            this.item.content = data;
            this.item.alignment = this.determineAlignment(element.alignment);
            this.item.padding = this.determinePadding(element.padding);
            this.item.type = element.item.type;
        });

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

    }

    /**
     * Alignment is returned as LEFT, CENTER, RIGHT
     * Determine class based on response
     */
    determineAlignment(alignment) {

        if (alignment == 'LEFT') {
            return 'text-left';
        } else if (alignment == 'CENTER') {
            return 'text-center';
        } else if (alignment == 'RIGHT') {
            return 'text-right';
        }

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding == 'SMALL') {
            return '10';
        } else if (padding == 'MEDIUM') {
            return '15';
        } else if (padding == 'LARGE') {
            return '30';
        } else if (padding == 'XLARGE') {
            return '60';
        }

    }

}
